<script setup>
import { renderRichText2 } from '~/utils/richtext'
const props = defineProps({ blok: Object })
const body = computed(() => renderRichText2(props.blok.body1))
</script>

<template>
  <div v-editable="blok" class="w-full pt-10">
		<!-- <div class="w-4 h-1 bg-primary-500 mb-4"></div> -->
		<h3 v-if="blok.title" class="text-4xl pb-4 font-bold">{{ blok.title }}</h3>
		<div class="first-letter:text-6xl first-letter:font-bold first-letter:mt-[0.1rem] first-letter:mr-3 first-letter:float-left
		 text-xl font-thin leading-8 text-block gap-10 md:columns-2" v-html="body"></div>
  </div>
</template>
 

<style>
.text-block a {
	color: #BF8DFF;
}
</style>